<template>
	<div class="t-login">
		<div class="t-login-card">
			<div class="t-logo-big">TaskFlow</div>
			<div class="t-tag">{{ tagline }}</div>

			<!-- forgot password form -->
			<template v-if="mode === 'forgot'">
				<label>אימייל</label>
				<input v-model="form.email" type="email" placeholder="you@company.com" @keyup.enter="submitForgot" />
				<div v-if="error" class="t-error">{{ error }}</div>
				<div v-if="info" class="t-error" style="background:#dcf7eb; color:#00805a;">{{ info }}</div>
				<button class="t-btn primary" :disabled="loading" @click="submitForgot">
					{{ loading ? "שולח..." : "שלח קישור איפוס" }}
				</button>
				<div class="t-switch"><span @click="setMode('login')">← חזרה להתחברות</span></div>
			</template>

			<!-- login / register form -->
			<template v-else>
				<div v-if="mode === 'register'">
					<label>שם מלא</label>
					<input v-model="form.name" placeholder="ישראל ישראלי" />
				</div>

				<label>אימייל</label>
				<input v-model="form.email" type="email" placeholder="you@company.com" @keyup.enter="submit" />

				<label>סיסמה</label>
				<input v-model="form.password" type="password" placeholder="••••••" @keyup.enter="submit" />

				<div v-if="error" class="t-error">{{ error }}</div>

				<button class="t-btn primary" :disabled="loading" @click="submit">
					{{ loading ? "אנא המתן..." : (mode === 'register' ? "צור חשבון" : "התחבר") }}
				</button>

				<div class="t-switch" style="margin-top:10px;">
					<span v-if="mode === 'login'" @click="setMode('forgot')">שכחתי סיסמה</span>
				</div>
				<div class="t-switch">
					<template v-if="mode === 'login'">
						אין לך חשבון? <span @click="setMode('register')">הירשם כאן</span>
					</template>
					<template v-else>
						כבר רשום? <span @click="setMode('login')">התחבר</span>
					</template>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
import { TasksAPI } from "./TasksApi";

export default {
	name: "TasksLogin",
	inheritAttrs: false,
	data() {
		return {
			mode: "login", // 'login' | 'register' | 'forgot'
			loading: false,
			error: "",
			info: "",
			form: { name: "", email: "", password: "" },
		};
	},
	computed: {
		tagline() {
			return ({
				login:    "התחברות למערכת המשימות",
				register: "יצירת חשבון חדש",
				forgot:   "איפוס סיסמה",
			})[this.mode];
		},
	},
	methods: {
		setMode(m) {
			this.mode  = m;
			this.error = "";
			this.info  = "";
		},
		async submit() {
			if (this.loading) return;
			this.error = "";
			if (!this.form.email || !this.form.password) {
				this.error = "יש למלא אימייל וסיסמה";
				return;
			}
			if (this.mode === "register" && !this.form.name) {
				this.error = "יש למלא שם מלא";
				return;
			}
			this.loading = true;
			const res = this.mode === "register"
				? await TasksAPI.register(this.form.name, this.form.email, this.form.password)
				: await TasksAPI.login(this.form.email, this.form.password);
			this.loading = false;

			if (res && res.token) {
				TasksAPI.setToken(res.token);
				TasksAPI.setUser(res.user);
				location.href = process.env.BASE_URL + "tasks";
				return;
			}
			const map = {
				invalid_credentials: "אימייל או סיסמה שגויים",
				email_exists:        "כבר קיים משתמש עם המייל הזה",
				invalid_input:       "אחד מהשדות לא תקין (סיסמה צריכה לפחות 6 תווים)",
				network:             "שגיאת רשת, נסה שוב",
			};
			this.error = map[res?.error] || "שגיאה לא ידועה";
		},
		async submitForgot() {
			if (this.loading) return;
			this.error = "";
			this.info  = "";
			if (!this.form.email) { this.error = "יש להזין אימייל"; return; }
			this.loading = true;
			const res = await TasksAPI.forgotPassword(this.form.email);
			this.loading = false;
			if (res && res.status === "ok") {
				this.info = "נשלח אליך מייל עם קישור איפוס (אם הכתובת קיימת במערכת)";
			} else if (res && res.error === "invalid_email") {
				this.error = "כתובת אימייל לא תקינה";
			} else {
				this.error = "שגיאה בשליחת המייל, נסה שוב";
			}
		},
	},
};
</script>
